module.exports = __webpack_public_path__ + "static/media/cyborg2.a01b28bb.png";